// extracted by css-extract-rspack-plugin
export default {"header":"header-Tj9mvA","scheduled":"scheduled-WYmgh8"};